import { jsxs, jsx } from 'react/jsx-runtime';
import { ImageWithIcon } from '@moim/common';
import { withPlacement } from '../../hoc/withPlacement.mjs';
import { TextComponent } from '../texts/component.mjs';
import { Wrapper, IconWrapper, Title, Extra } from './styled.mjs';

var RowTile = function RowTile(_ref) {
  var title = _ref.title,
    right = _ref.right,
    left = _ref.left,
    extra = _ref.extra,
    href = _ref.href;
  var hrefWithTitle = title.content ? "".concat(href, "?title=").concat(title.content) : href;
  return jsxs(Wrapper, {
    href: hrefWithTitle,
    children: [left && jsx(IconWrapper, {
      children: jsx(ImageWithIcon, {
        imageUrl: left.src
      })
    }), jsx(Title, {
      children: jsx(TextComponent, {
        color: title.color,
        align: title.align,
        border: title.border,
        fontWeight: title.fontWeight,
        fontFamily: title.fontFamily,
        letterSpacing: title.letterSpacing,
        subType_v2: title.subType_v2,
        children: title.content
      })
    }), extra && jsx(Extra, {
      children: extra.content
    }), right && jsx(IconWrapper, {
      children: jsx(ImageWithIcon, {
        imageUrl: right.src
      })
    })]
  });
};
var index = withPlacement(RowTile);

export { index as default };
